import { SmallWholesaleOrder } from './small-wholesale-order.type';
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Region } from './region.type';
import { HttpErrorResponse } from '@angular/common/http';

export const SMALL_WHOLESALE_GATEWAY =
  new InjectionToken<SmallWholesaleGateway>('SmallWholesaleGateway');

export interface SmallWholesaleGateway {
  getRegions(): Observable<Region[]>;
  submitOrder(
    order: SmallWholesaleOrder,
  ): Observable<{ done: true } | HttpErrorResponse>;
  getConsentToPersonalDataProcessing(): void;
}
